module.exports = __webpack_public_path__ + "img/newyear-pop.872f7cb2.png";